import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 38,
  height: 34,
}

const PartyRoom = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 38 34.14'
  >
    <g transform='translate(0 -26.001)' fill={color}>
      <g transform='translate(0 30.923)'>
        <path
          d='M17.869,95.619a.743.743,0,0,0-.553-.7L10.24,93.051h0l-2.665-.7a.742.742,0,0,0-.821.328,21.561,21.561,0,0,0-2.428,5.571c-.869,3.193-.722,5.932.427,7.921a5.674,5.674,0,0,0,2.844,2.477L4.866,118.668.931,117.63a.742.742,0,0,0-.379,1.435l4.641,1.224,4.653,1.227a.742.742,0,0,0,.379-1.435L6.3,119.046,9.03,109.025a5.84,5.84,0,0,0,.8.056c3.309,0,6.043-2.782,7.311-7.442A21.427,21.427,0,0,0,17.869,95.619Zm-2.16,5.631c-1.082,3.974-3.28,6.347-5.879,6.347a4.5,4.5,0,0,1-1.146-.152,4.244,4.244,0,0,1-2.648-2.019,7.488,7.488,0,0,1-.7-4.684,17.431,17.431,0,0,0,2.814.224,31.928,31.928,0,0,0,4.025-.318,15.769,15.769,0,0,1,3.732-.188Q15.815,100.859,15.709,101.25ZM16.176,99a16.564,16.564,0,0,0-4.185.175,21.764,21.764,0,0,1-6.4.107q.073-.318.162-.644a20.015,20.015,0,0,1,1.978-4.711l1.179.311c-.214.412-.411.835-.564,1.18a.742.742,0,1,0,1.356.6c.24-.539.475-1.017.684-1.4l6,1.583A20.2,20.2,0,0,1,16.176,99Z'
          transform='translate(0 -92.323)'
        />
      </g>
      <g transform='translate(20.125 30.923)'>
        <path d='M384.444,469.133h0l-4.615,1.217Z' transform='translate(-371.763 -441.167)' />
        <path d='M379.366,485.533l-.037.01Z' transform='translate(-371.301 -456.349)' />
        <path
          d='M289.011,118.157a.742.742,0,0,0-.907-.528l-3.935,1.038-2.729-10.023a5.674,5.674,0,0,0,2.844-2.477c1.148-1.989,1.3-4.728.427-7.921a21.564,21.564,0,0,0-2.428-5.571.742.742,0,0,0-.821-.328l-9.744,2.57a.742.742,0,0,0-.553.7,21.526,21.526,0,0,0,.58,5.44c0,.025.01.049.018.073.042.17.084.34.13.508,1.268,4.66,4,7.442,7.311,7.442h0a5.833,5.833,0,0,0,.8-.056l2.728,10.021-3.923,1.035a.742.742,0,1,0,.379,1.435l4.651-1.227h0l4.642-1.224A.742.742,0,0,0,289.011,118.157Zm-16.365-21.95,8.655-2.283a20.01,20.01,0,0,1,1.978,4.711q.19.7.309,1.359a9.961,9.961,0,0,0-1.38-.033c-.08-.543-.2-1.11-.3-1.549a.742.742,0,1,0-1.447.329c.113.5.2.952.261,1.343-.336.038-.676.081-1.019.125a20.83,20.83,0,0,1-6.614.073A20.105,20.105,0,0,1,272.646,96.207Zm6.56,11.389h0c-2.465,0-4.569-2.136-5.7-5.747a17.346,17.346,0,0,0,2.365.16,30.961,30.961,0,0,0,4.026-.327,14.325,14.325,0,0,1,3.878-.17,6.981,6.981,0,0,1-.772,3.913,4.244,4.244,0,0,1-2.648,2.019A4.49,4.49,0,0,1,279.206,107.6Z'
          transform='translate(-271.161 -92.322)'
        />
      </g>
      <g transform='translate(18.257 26.001)'>
        <path
          d='M246.741,26a.742.742,0,0,0-.742.742v1.936a.742.742,0,0,0,1.484,0V26.743A.742.742,0,0,0,246.741,26Z'
          transform='translate(-245.999 -26.001)'
        />
      </g>
      <g transform='translate(14.231 27.597)'>
        <path
          d='M194.113,49.555l-.983-1.677a.742.742,0,0,0-1.28.751l.983,1.677a.742.742,0,0,0,1.28-.751Z'
          transform='translate(-191.747 -47.511)'
        />
      </g>
      <g transform='translate(21.3 27.598)'>
        <path
          d='M289.1,47.615a.742.742,0,0,0-1.016.265l-.983,1.677a.742.742,0,1,0,1.28.751l.983-1.677A.742.742,0,0,0,289.1,47.615Z'
          transform='translate(-286.998 -47.513)'
        />
      </g>
      <g transform='translate(28.87 34.436)'>
        <path
          d='M390.447,140.177v0a.742.742,0,0,0-1.419.435l0,.016a.742.742,0,0,0,1.416-.446Z'
          transform='translate(-388.995 -139.651)'
        />
      </g>
      <g transform='translate(7.441 35.442)'>
        <ellipse cx='1' cy='0.5' rx='1' ry='0.5' transform='translate(-0.442 0.185)' />
      </g>
    </g>
  </svg>
)

export default PartyRoom
